"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
var _vuex = require("vuex");
var _emitter = _interopRequireDefault(require("element-ui/src/mixins/emitter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'IceSelect',
  mixins: [_emitter.default],
  model: {
    prop: 'value',
    event: 'changevalue'
  },
  props: {
    value: [String, Array, Number],
    mapTypeCode: String,
    dataUrl: String,
    textProp: {
      type: String,
      default: 'dictLabel'
    },
    codeProp: {
      type: String,
      default: 'dictValue'
    },
    valueModel: {
      // 表示选择后返回值，多选模式下返回值：[1,2,3]  "1,2,3"
      type: String,
      default: 'array',
      validator: function validator(value) {
        return ['string', 'array'].indexOf(value) !== -1;
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    text: {
      type: String
    },
    disabledList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
    /*,
            parentValue: String//父选中值*/
  },
  data: function data() {
    return {
      selectValue: null,
      dataList: [],
      selectList: []
    };
  },
  watch: {
    value: function value(newValue, oldValue) {
      if (this.multiple) {
        if (!newValue) {
          this.selectValue = [];
          return;
        }
        if (this.valueModel == 'string') {
          this.selectValue = newValue.split(',');
        } else if (this.valueModel == 'array') {
          this.selectValue = newValue;
        }
      } else {
        if (!newValue) {
          this.selectValue = '';
          return;
        }
        this.selectValue = newValue + '';
      }
    },
    mapTypeCode: function mapTypeCode() {
      this.getSelectList();
    },
    dataList: function dataList() {
      var _this = this;
      this.selectList = this.dataList.map(function (item) {
        return {
          value: item[_this.codeProp],
          label: item[_this.textProp]
        };
      });
    },
    datamap: function datamap() {
      this.getSelectList();
    },
    options: function options() {
      this.dataList = this.options;
    },
    selectList: function selectList() {
      if (this.valueModel == 'string' && this.multiple) {
        this.selectValue = this.value ? this.value.split(',') : [];
      } else if (this.valueModel == 'array' && this.multiple) {
        this.selectValue = this.value ? this.value : [];
      } else {
        this.selectValue = this.value + '';
      }
    }
  },
  methods: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapMutations)('datamapStore', ['addUndoTypeCodes'])), (0, _vuex.mapGetters)('datamapStore', ['getDataMap'])), {}, {
    changeValue: function changeValue(value, text) {
      var _this2 = this,
        _arguments = arguments;
      //  debugger

      if (this.multiple) {
        var labels = this.selectList.filter(function (item) {
          return _this2.selectValue.find(function (ch) {
            return ch == item.value;
          });
        }).map(function (item) {
          return item.label;
        });
        if (this.valueModel == 'string') {
          this.$emit('update:text', labels.join(','));
          this.$emit('changevalue', this.selectValue.join(','));
        } else {
          this.$emit('update:text', labels);
          this.$emit('changevalue', this.selectValue);
        }
      } else {
        var _labels = this.selectList.filter(function (item) {
          return item.value == _this2.selectValue;
        }).map(function (item) {
          return item.label;
        });
        this.$emit('update:text', _labels.join(','));
        this.$emit('changevalue', this.selectValue + '');
      }
      this.$nextTick(function () {
        _this2.dispatch.apply(_this2, ['ElFormItem', 'el.form.blur'].concat((0, _toConsumableArray2.default)(_arguments)));
      });
      return false;
    },
    getSelectList: function getSelectList() {
      if (this.mapTypeCode) {
        var datamap = this.getDataMap()(this.mapTypeCode);
        if (datamap) {
          var list = [];
          for (var key in datamap) {
            list.push({
              value: key,
              label: datamap[key]
            });
          }
          this.selectList = list;
        } else {
          console.warn('未找到数据字典：typecode=' + this.mapTypeCode);
        }
      }
    }
  }),
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapState)('datamapStore', ['datamap'])), {}, {
    multiple: function multiple() {
      return this.$refs.select.multiple;
    },
    filterSelectList: function filterSelectList() {
      var _this3 = this;
      return this.selectList.filter(function (item) {
        return _this3.disabledList.indexOf(item.value) == -1;
      });
    }
  }),
  created: function created() {
    if (this.mapTypeCode) {
      this.addUndoTypeCodes(this.mapTypeCode);
    }
  },
  mounted: function mounted() {
    var _this4 = this;
    if (this.dataUrl) {
      this.$axios.get(this.dataUrl).then(function (result) {
        _this4.dataList = result.data;
      });
    } else if (this.mapTypeCode) {} else if (this.options) {
      this.dataList = this.options;
    }
    this.getSelectList();
  }
};